import Validation from '../lib/validation'

function validate(data, action) {
  const validator = new Validation(data)
  validator.isRequired('firstName', 'Jméno není vyplněno')
  validator.isRequired('lastName', 'Příjmenní není vyplněno')
  validator.isRequired('email', 'Email je povinný')
  validator.isRequired('role', 'Role je povinná')
  switch (action) {
    case 'create': {
      validator.isRequired('password', 'Heslo není vyplněno')
      break
    }
    // no default
  }
  if (data.password) {
    validator.isRequired('passwordConfirmation', '"Heslo znovu" není vyplněno.')
    validator.areEqual('password', 'passwordConfirmation', 'Zadaná hesla se neshodují.')
  }
  return validator.validate()
}

export const validateCreate = (data) => validate(data, 'create')
export const validateUpdate = (data) => validate(data, 'update')

export default validate



// WEBPACK FOOTER //
// ./src/common/users/validations.js